module.exports = __webpack_public_path__ + "assets/08bad9f153ec0cce5385be27eafa081b.png";